// extracted by mini-css-extract-plugin
export var chip = "_4y-0";
export var filterDropdown = "_4y-5";
export var filterItem = "_4y-6";
export var icon = "_4y-1";
export var removeButton = "_4y-3";
export var removeIcon = "_4y-4";
export var separator = "_4y-2";